import { baseSliceWithTags } from '../baseSlice';
import { authHeader, deviceHeader } from '../../constants/authenticationHeader';
const authApi = baseSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (auth) => ({
        url: '/rest/users/login',
        method: 'POST',
        data: { ...auth, tmr: true },
        csrf: deviceHeader(),
      }),
    }),
    createInternalSso: builder.mutation({
      query: ({ target, returnPath }) => ({
        url: '/rest/auth/sso/create',
        method: 'POST',
        data: {
          source: 'tmr',
          target,
          return_path: returnPath,
        },
        csrf: authHeader(),
      }),
    }),
    exchangeInternalSso: builder.mutation({
      query: ({ code }) => ({
        url: '/rest/auth/sso/exchange',
        method: 'POST',
        data: {
          code,
          target: 'tmr',
        },
        csrf: deviceHeader(),
      }),
    }),
  }),
});
export const {
  useLoginMutation,
  useCreateInternalSsoMutation,
  useExchangeInternalSsoMutation,
} = authApi;
export default authApi;
